















































import Vue from 'vue';

export default Vue.extend({
  props: {
    header: {
      type: String,
      required: true
    },
    headerClass: {
      type: String,
      default: 'text-h6 font-weight-regular text-high-emphasis'
    },
    level: {
      type: Number,
      default: 4
    },
    description: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      actionBtnDefaults: {
        primary: {
          VBtn: {
            class: 'rounded',
            height: '',
            color: 'primary',
            density: 'default',
            flat: true,
            prependIcon: 'mdi-plus'
          }
        },
        secondary: {
          VBtn: {
            class: 'rounded mr-2',
            height: '',
            density: 'default',
            flat: true
          }
        },
        tertiary: {
          VBtn: {
            class: 'rounded',
            height: '',
            density: 'default',
            flat: true
          }
        }
      }
    };
  }
});
